import React from "react";
import useApi, { useApis } from "AppSrc/utils/hooks/fetching";
import Traec from "traec";
import TipsSpinner from "AppSrc/utils/spinners/tipsSpinner";
import Moment from "moment";
import { Redirect } from "react-router";
const { Im } = Traec;

function ReportRow({ item }) {
  let _id = item.get("object_id");
  let datetime = new Moment(item.get("last_report_date"));
  return (
    <tr>
      <td>
        <a target="_blank" href={`/company/${_id}`}>
          {_id}
        </a>
      </td>
      <td>{item.get("name")}</td>
      <td>{datetime.format("MMM Do YYYY, h:mm:ss a")}</td>
      <td>
        <a target="_blank" href={`/api/report/sbcc/${_id}/pdf`}>
          PDF
        </a>
      </td>
    </tr>
  );
}

export function ReportAdminPage() {
  return (
    <div className="container">
      <button className="btn btn-sm btn-primary" onClick={() => (location.href = "/accounts/profile")}>
        Back
      </button>
      <ReportAdmin />
    </div>
  );
}

export default function ReportAdmin() {
  let { fetches, isLoading } = useApis({
    companies: useApi("/api/company/"),
    reports: useApi("/api/report/sbcc")
  });

  if (isLoading()) {
    return <TipsSpinner />;
  }

  let companyIdNameMap = fetches.companies.data.reduce(
    (acc, cur) => acc.set(cur.get("uid").substring(0, 8), cur.get("name")).set(cur.get("uid"), cur.get("name")),
    Im.Map()
  );

  let rows = fetches.reports.data
    .filter(i => i.get("last_report_date"))
    .filter(i => companyIdNameMap.has(i.get("object_id")))
    .sortBy(i => i.get("last_report_date"))
    .reverse()
    .map((item, i) => {
      let _id = item.get("object_id");
      return <ReportRow key={i} item={item.set("name", companyIdNameMap.get(_id))} />;
    });

  if (!rows.size) {
    return <p>No reports</p>;
  }

  return (
    <table width="100%" className="table table-sm">
      <thead>
        <tr>
          <th scope="col">Company ID</th>
          <th scope="col">Company Name</th>
          <th scope="col">Last Report Date</th>
          <th scope="col">Get Report</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
}
